import me from "models/me";
import { canAccessB2BPOSIntegration } from "components/helpers/b2b/can-access-pos-integration";
import { getStore } from "store";

export default function (_nextState, replace, callback) {
    const { lsid } = getStore().getState();

    if (!canAccessB2BPOSIntegration(me, lsid)) {
        replace({
            pathname: "/404",
        });
    }
    callback();
}
